/** Production origin without trailing slash (matches Docker build-arg VITE_SITE_URL). */
export function getSiteUrl(): string {
  const raw = import.meta.env.VITE_SITE_URL;
  const base = typeof raw === 'string' && raw.length > 0 ? raw : 'https://www.yeswecanhq.com';
  return base.replace(/\/$/, '');
}

export function canonicalUrl(path: string): string {
  const site = getSiteUrl();
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${site}${p}`;
}
